import { OrganisationModel, UserModel } from 'back-end/src/models/dbModels'
import { OrganisationRoleEnum } from './Organisation'

export interface IUser {
  display_name: string
  email: string | null
  first_name: string | null
  last_name: string | null
  image_url: string | null
  organisation_id: number
  id: number
  position: string | null
  verified: boolean
  step: number
  states: string[] | null
  timezone: string | null
  is_superuser: boolean
  organisation_role: OrganisationRoleEnum
  employee_id: string | null
  area: string | null
  location: string | null
  department: string | null
  custom_1: string | null
  custom_2: string | null
  password_last_updated_at: string | null
  last_activity_at: null
  profile_img_url: string | null
  account_name: string | null
  userIdentity: string
  phone_number: string | null
}

export type Users = IUser[]

export enum UsersOverviewOrderColumn {
  id = 'id',
  display_name = 'display_name',
  pathwayEnrolmentsCount = 'pathway_enrolments_count',
  resourceViewsCount = 'resource_views_count',
  attendedEventsCount = 'attended_events_count',
  certificationEnrolmentsCount = 'certification_enrolments_count',
  workbooksCount = 'workbooks_count',
  surveysCount = 'surveys_count',
  lastActivityAt = 'last_activity_at'
}

export enum UserCreationMethodEnum {
  MANUAL = 'MANUAL', // created on the API with a simple GQL call
  SELF_SIGNUP = 'SELF_SIGNUP', // user signed up on looop login page
  SSO_JIT = 'SSO_JIT', // from SSO login "just in time" provisioning
  SCIM = 'SCIM',
  FOURTH_SCIM = 'FOURTH_SCIM',
  BAMBOOHR_SCIM = 'BAMBOOHR_SCIM',
  SECRET_SIGNUP_LINK = 'SECRET_SIGNUP_LINK',
  CSV_IMPORT = 'CSV_IMPORT'
}

export type UserModelWithOrganisation = UserModel & {
  organisation: OrganisationModel
}
